import {effect, Effect} from '@mazechazer/redux-loop'

export function timeout<T>(ms: number, action: T): Effect<T> {
    return effect(
        () => new Promise(resolve => setTimeout(() => resolve(action), ms))
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Time.ts